import type { JSX } from 'react';
import { ConfigSection } from '../components/ConfigSection.js';

export function BillingPage(): JSX.Element {
  return (
    <ConfigSection
      title={"Cobrança: assinaturas, eventos e reconciliação"}
      description={"Área do plano que depende de código ou credencial externa."}
      blockedBy={[
      'Nenhuma credencial de RevenueCat ou Stripe configurada (`REVENUECAT_SECRET_KEY`/`STRIPE_SECRET_KEY`).',
      'Sem credencial não existe webhook autenticado, ledger nem sandbox real — e o painel não simula sucesso.',
      'O worker já registra divergência de período vencido como ocorrência para revisão.'
]}
      planned={[
      'Eventos do provedor deduplicados por `(provider, eventId)`.',
      'Reconciliação com o estado atual do provedor, sem editar estado de loja manualmente.'
]}
    />
  );
}